import type {useRouter} from 'next/navigation';

/**
 * Removes a single query param from the current URL, keeping the remaining
 * params, the hash and the scroll position.
 *
 * Replaces through the router rather than `window.history` so the router's own
 * view of the URL stays in sync — a stale router can otherwise re-serialize the
 * removed param back into the URL on the next navigation. `scroll: false` keeps
 * the visitor where they were instead of jumping to the top of the page.
 */
export function removeUrlSearchParam(router: ReturnType<typeof useRouter>, param: string): void {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(param)) {
        return;
    }

    params.delete(param);
    const search = params.toString();
    const nextUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;

    router.replace(nextUrl, {scroll: false});
}
